<div class="flex flex-col justify-content mt-[80px]">
    <img class="h-[40px]" src="/images/shared/why-choose-us.svg" alt="">
    <app-healthcare-card-container [cardInfo]="cardInfo"></app-healthcare-card-container>
</div>